import { defineComponent as _defineComponent } from 'vue'
import useRoomMoreControl from './useRoomMoreHooks';
import SvgIcon from '../common/base/SvgIcon.vue';
import CopyIcon from '../common/icons/CopyIcon.vue';
import '../../directives/vTap';


export default /*#__PURE__*/_defineComponent({
  __name: 'indexH5',
  emits: ['on-close-contact'],
  setup(__props, { emit }) {

const { t, onCopy, contactContentList } = useRoomMoreControl();



function handleCloseContact() {
  emit('on-close-contact');
}

return { __sfc: true,t, onCopy, contactContentList, emit, handleCloseContact, SvgIcon, CopyIcon }
}

})